import $ from 'jquery';
"use strict";

var myDataStructureShortcuts=new Array();

function callBrsService() {
    var req = new XMLHttpRequest();
    req.open("GET", window.location.origin + "/brs/cem/CemInfoServlet.xml?brs_profile=true");
    req.addEventListener("load", function () {
        if (req.status != 200 || req.responseXML == null || req.responseXML.getElementsByTagName("CodeRetourIb")[0] == 1) {
           console.error("error calling brs service : " + req.status + " " + req.statusText);
        } else {
			extractShortcutsFromRequest(req.responseXML);
            updateDomForBrsShortcuts();
        }
    });
    req.addEventListener("error", function () {
        console.error("Erreur réseau");
    });
    req.send(null);
}

function extractShortcutsFromRequest(root) {
    var lien=root.getElementsByTagName("LienRaccourcis")[0];
    myDataStructureShortcuts["NbElem"]=lien.getElementsByTagName("NbElem")[0].firstChild.nodeValue;
    myDataStructureShortcuts["IndicRaccourcis"]=root.getElementsByTagName("Raccourcis")[0];
    var raccInfo=myDataStructureShortcuts["IndicRaccourcis"];
    var nbElem =myDataStructureShortcuts["NbElem"];
    var j=1;
    for (var i=1;i<=nbElem && raccInfo;i++) {
        var info=raccInfo.childNodes[i-1];
        if (info) {
            if (info.getElementsByTagName("Lib")[0].firstChild.nodeValue == decodeURI("Palmar%C3%A8s + fortes hausses Eurolist")) {
                myDataStructureShortcuts["RACC_Lib_fix"] = info.getElementsByTagName("Lib")[0].firstChild.nodeValue;
                myDataStructureShortcuts["RACC_Uri_fix"] = info.getElementsByTagName("Uri")[0].firstChild.nodeValue;
            } else {
                myDataStructureShortcuts["RACC_Lib_"+j] = info.getElementsByTagName("Lib")[0].firstChild.nodeValue;
                myDataStructureShortcuts["RACC_Uri_"+j] = info.getElementsByTagName("Uri")[0].firstChild.nodeValue;
                j++;
            }
        }
    }
}

function updateDomForBrsShortcuts() {
    if ($('#menuDynBlocCemNet2g-list').length) {
        var list = $('#menuDynBlocCemNet2g-list');
        list[0].appendChild(buildSeparatedShortcut());
        buildCustomShortcut(list);
        $('#menuDynBlocCemNet2g-ngim').css('visibility', 'visible');

    }
}

function buildSeparatedShortcut() {
    var liShortcut = document.createElement("li");
    liShortcut.setAttribute("class", "dcw_brs-shortcut_item is-separated");
    var href = document.createElement("a");
    href.setAttribute("href",myDataStructureShortcuts["RACC_Uri_fix"]);
    href.setAttribute("data-tms-click-type","N");
    href.setAttribute("data-tms-element-label",myDataStructureShortcuts["RACC_Lib_fix"].replace(/\s+/g, '-').toLowerCase());
    href.setAttribute("data-tms-container-label","brs-shortcuts");
    href.appendChild(document.createTextNode(myDataStructureShortcuts["RACC_Lib_fix"]));
    liShortcut.appendChild(href);
    return liShortcut;
}

function buildCustomShortcut(list) {
   for (var i=1; i<=myDataStructureShortcuts["NbElem"]; i++) {
    var link = myDataStructureShortcuts["RACC_Uri_"+i];
    var label = myDataStructureShortcuts["RACC_Lib_"+i];
    if (link && label) {
        var liShortcut = document.createElement("li");
        if (i == 1) {
            liShortcut.setAttribute("class", "dcw_brs-shortcut_item is-current");
        } else {
            liShortcut.setAttribute("class", "dcw_brs-shortcut_item");
        }
        var href = document.createElement("a");
        href.setAttribute("href",link);
        href.setAttribute("data-tms-click-type","N");
        href.setAttribute("data-tms-element-label",label.replace(/\s+/g, '-').toLowerCase());
        href.setAttribute("data-tms-container-label","brs-shortcuts");
        href.appendChild(document.createTextNode(label));
        liShortcut.appendChild(href);
        list[0].getElementsByClassName("dcw_brs-shortcut_item is-separated")[0].parentNode.insertBefore(liShortcut, list[0].getElementsByClassName("dcw_brs-shortcut_item is-separated")[0]);
    }
  }
}

/* Call service to update shortcuts for BRS */
const updateBrsShortcuts = function updateBrsShortcuts() {
    if ($('#menuDynBlocCemNet2g-ngim').length) {
        callBrsService();
    }
};

export {updateBrsShortcuts};




// WEBPACK FOOTER //
// ./src/js/cms/commons/navigations/brs-shortcut.js